/**
 * KAN-834: ссылка входа менеджера в приложение (карточка менеджера в кабинете).
 * Выдаёт владелец и оператор; ошибка сервера (менеджер в архиве, вход
 * отключён) отдаётся текстом для показа в блоке.
 */
import { useMutation } from '@tanstack/react-query';
import { appLinkApi } from '@/services/api/appLink';
import { extractErrorMessage } from '@/lib/extractErrorMessage';

export function useManagerAppLink(managerId: string) {
  const create = useMutation({
    mutationFn: () => appLinkApi.createManagerAppLink(managerId),
  });
  return {
    create,
    link: create.data ?? null,
    error: create.error ? extractErrorMessage(create.error, 'Не удалось получить ссылку') : null,
  };
}
